export default function (widgetID, widgetOptions) {
  const widgetName = widgetID;
  const widgetOpts = widgetOptions;
  const $widgetHTML = $(`#${widgetName}`);

  const linkedImages = true;
  const linkNewTab = false;

  return saffire.widgets.cardWidget($widgetHTML, {
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      $widgetHTML.find('.card-content').remove();

      if (widgetData.length <= 0) {
        $(`#${widgetName}`).remove();
      } else {
        changeFormatCards(widgetData);
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    maxItemsVisible: 12,
    itemsPerPanel: 1,
  });

  function changeFormatCards(data) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $card = $(this);
      if (!data[x].URL) {
        $card.removeAttr('href');
      }
      if (!linkNewTab) {
        $card.removeAttr('target');
      }
      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
